import { useAppSelector } from "src/store/hooks";

type Properties = {
    label: string;
    onClick: () => void;
    isHidden?: boolean;
    disabled?: boolean;
    type?: 'submit' | 'reset' | 'button';
    className?: string;
};

const SecondaryButton = (props: Properties) => {
    const config = useAppSelector(state => state.globalState.config);

    if (props.isHidden) {
        return <></>;
    }

    return (
        <button 
            onClick={props.onClick} 
            className={`secondary ${props.className || ''}`}
            disabled={props.disabled}
            type={props.type || 'button'}
            style={{ 
                borderColor: config?.themeColor || '#acbcbc',
                borderWidth: '2px',
                borderStyle: 'solid',
                color: config?.themeColor || '#acbcbc'
            }}
        >
            {props.label}
        </button>
    );
};
export default SecondaryButton;
